import { JSX } from "react";

export const ArrowBackIcon = ({ ...props }: JSX.IntrinsicElements["svg"]) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_2305_6752"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect
          x="16"
          y="16.3604"
          width="16"
          height="16"
          transform="rotate(180 16 16.3604)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2305_6752)">
        <path
          d="M10.7822 7.69372L7.51549 4.42705C7.38216 4.29372 7.31827 4.13816 7.32383 3.96038C7.32938 3.78261 7.39883 3.62705 7.53216 3.49372C7.66549 3.3715 7.82105 3.30761 7.99883 3.30205C8.1766 3.2965 8.33216 3.36039 8.46549 3.49372L12.8655 7.89372C12.9322 7.96038 12.9794 8.03261 13.0072 8.11038C13.0349 8.18816 13.0488 8.2715 13.0488 8.36038C13.0488 8.44927 13.0349 8.53261 13.0072 8.61038C12.9794 8.68816 12.9322 8.76039 12.8655 8.82705L8.46549 13.2271C8.34327 13.3493 8.19049 13.4104 8.00716 13.4104C7.82383 13.4104 7.66549 13.3493 7.53216 13.2271C7.39883 13.0937 7.33216 12.9354 7.33216 12.7521C7.33216 12.5687 7.39883 12.4104 7.53216 12.2771L10.7822 9.02705L3.33216 9.02705C3.14327 9.02705 2.98494 8.96316 2.85716 8.83539C2.72938 8.70761 2.66549 8.54927 2.66549 8.36039C2.66549 8.1715 2.72938 8.01316 2.85716 7.88539C2.98494 7.75761 3.14327 7.69372 3.33216 7.69372L10.7822 7.69372Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
